/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SubscriberLogDetail {
  logDate?: Date;
  logHost?: string;
  logMessage?: string;
  newStatus?: string;
  newStatusId?: number;
  oldStatus?: string;
  oldStatusId?: number;
  subscriberId?: number;
  subscriberLogId?: number;
}
